module.exports = __webpack_public_path__ + "static/media/ENTREGA_DE_ANFORA.24492a42.png";